// Access gate utilities — APEX private preview
const ACCESS_KEY = 'apex_access_granted';
const ACCESS_CODE = 'APEX2026';
const MAX_AGE_MS = 24 * 60 * 60 * 1000; // 24 hours

export function isAccessGranted() {
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.get('access') === ACCESS_CODE) {
      localStorage.setItem(ACCESS_KEY, String(Date.now()));
      return true;
    }
    const raw = localStorage.getItem(ACCESS_KEY);
    if (!raw) return false;
    const ts = Number(raw);
    if (!Number.isFinite(ts)) return false;
    if (Date.now() - ts > MAX_AGE_MS) {
      localStorage.removeItem(ACCESS_KEY);
      return false;
    }
    return true;
  } catch {
    return false;
  }
}
